// Configuração de tema para a aplicação
// Inspirado no TesteDesign.js com cores em tons pastel

// Definir cores
const theme = {
  colors: {
    primary: '#6695ED', // Azul pastel
    primaryLight: 'rgba(102, 149, 237, 0.1)',
    primaryDark: '#4a77d4',
    success: '#66CDAA', // Verde pastel
    successLight: 'rgba(102, 205, 170, 0.1)',
    successDark: '#4daf8c',
    danger: '#FFA07A', // Salmão claro
    dangerLight: 'rgba(255, 160, 122, 0.1)',
    dangerDark: '#ff8266',
    warning: '#FFD580', // Amarelo pastel
    warningLight: 'rgba(255, 213, 128, 0.1)',
    warningDark: '#ffc966',
    info: '#87CEFA', // Azul céu claro
    infoLight: 'rgba(135, 206, 250, 0.1)',
    infoDark: '#6ec2f7',
    purple: '#B19CD9', // Lavanda
    purpleLight: 'rgba(177, 156, 217, 0.1)',
    purpleDark: '#9a81cc',
    pink: '#FFB6C1', // Rosa claro
    pinkLight: 'rgba(255, 182, 193, 0.1)',
    pinkDark: '#ff9aad',
    dark: '#4A5568', // Cinza escuro mais suave
    darkLight: 'rgba(74, 85, 104, 0.1)',
    gray: '#A0AEC0',
    grayLight: '#F7FAFC',
    text: '#4A5568',
    border: '#E2E8F0',
    background: '#F9FBFD'
  },
  
  // Componentes comuns
  card: {
    borderRadius: '16px',
    boxShadow: '0 3px 10px rgba(0,0,0,0.06)',
    backgroundColor: 'white',
    padding: '20px 20px 20px 24px'
  },

  // Tipografia
  typography: {
    fontFamily: "'Inter', sans-serif",
    heading: {
      fontSize: '1.5rem',
      fontWeight: 600,
      color: '#4A5568'
    },
    subheading: {
      fontSize: '0.875rem',
      color: '#A0AEC0'
    },
    value: {
      fontSize: '1.75rem',
      fontWeight: 600,
      color: '#4A5568',
      marginTop: '12px',
      marginBottom: '8px'
    },
    label: {
      fontSize: '0.75rem',
      fontWeight: 500,
      color: '#A0AEC0',
      textTransform: 'uppercase',
      letterSpacing: '0.03em'
    },
    small: {
      fontSize: '0.75rem',
      color: '#A0AEC0'
    }
  },

  // Botões
  button: {
    primary: {
      backgroundColor: '#6695ED',
      color: 'white',
      border: 'none',
      borderRadius: '8px',
      padding: '8px 16px',
      fontWeight: 500,
      boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
    },
    secondary: {
      backgroundColor: 'white',
      color: '#4A5568',
      border: '1px solid #E2E8F0',
      borderRadius: '8px',
      padding: '8px 16px',
      fontWeight: 500,
      boxShadow: '0 1px 3px rgba(0,0,0,0.05)'
    }
  },

  // Inputs
  input: {
    backgroundColor: 'white',
    border: '1px solid #E2E8F0',
    borderRadius: '8px',
    padding: '8px 12px',
    fontSize: '0.875rem',
    boxShadow: '0 1px 3px rgba(0,0,0,0.05)'
  },

  // Ícones
  iconBox: {
    borderRadius: '12px',
    width: '42px',
    height: '42px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },

  // Tabelas
  table: {
    header: {
      backgroundColor: '#F7FAFC',
      padding: '12px 20px',
      fontWeight: 600,
      color: '#4A5568',
      borderBottom: '1px solid #E2E8F0'
    },
    cell: {
      padding: '12px 20px',
      borderBottom: '1px solid #E2E8F0'
    }
  }
};

export default theme; 